export const PermissionDenied = () => <div className="p-4 text-danger">Permission Denied</div>;